
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";
import { 
  // Feature,
  FeatureBase,
  // Limitation 
} from "@models";


export class Gift extends DandDFeatureSource {
  data_type: DataType = "gift";
  feature_source_type = "Gift";
  type = "";
  use_gift_levels = false;
  max_level = 1;

  get gift_type() {
    return this.type;
  }

  parse_errors: string[] = [];

  constructor(obj?: any) {
    super(obj, "Gift");
    if (obj) {
      this.type = obj ? obj.type : "";
      // this.race_id = obj.race_id ? obj.race_id : "";
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
      this.use_gift_levels = obj.use_gift_levels ? obj.use_gift_levels : false;
      this.max_level = obj.max_level ? obj.max_level : 1;
    }
  }

  get_detail_format() {
    const str = `${super.get_detail_format()}; ${this.gift_type}`;
    return str.trim();
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj ? obj.type : "";
  //     // this.race_id = obj.race_id ? obj.race_id : "";
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //     this.use_gift_levels = obj.use_gift_levels ? obj.use_gift_levels : false;
  //     this.max_level = obj.max_level ? obj.max_level : 1;
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      // race_id: this.race_id,
      type: this.type,
      use_gift_levels: this.use_gift_levels,
      max_level: this.max_level
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      // race_id: this.race_id,
      type: this.type,
      use_gift_levels: this.use_gift_levels,
      max_level: this.max_level
    };
  }

  copy(copyMe: Gift, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    // this.race_id = copyMe.race_id;
    this.type = copyMe.type;
    this.use_gift_levels = copyMe.use_gift_levels;
    this.max_level = copyMe.max_level;
  }

  clone(drop_ids = false): Gift {
    const new_obj = new Gift();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}